import { PageDataHandler } from "@/lib/utility/data/page-data-handler";
import { Person, IPerson } from "@/models/person.entity";
import { MrfiktivMultipleIdsDtoGen, MrfiktivPersonControllerGetParamsGen } from "@/services/mrfiktiv/v1/data-contracts";
import store from "@/store/VuexPlugin";
import { Action, Module, Mutation, getModule } from "vuex-module-decorators";
import { PaginatedBaseStore } from "../paginated-base.store";
import { PersonDataAccessLayer } from "./access-layers/person.access-layer";
import { PaginationFilterListElement } from "./base-pagination.store";
import { PersonPageDataProvider } from "./page-data-provider/person.page-data-provider";
import personService from "@/services/mrfiktiv/services/person.service";

@Module({
  dynamic: true,
  namespaced: true,
  name: "person",
  store
})
export class PersonPaginationStore extends PaginatedBaseStore<IPerson, MrfiktivPersonControllerGetParamsGen> {
  protected _data = PersonDataAccessLayer;
  protected _pageProvider = PersonPageDataProvider;
  protected _pager = new PageDataHandler(this._data, this._pageProvider);

  filterOptions: PaginationFilterListElement[] = Person.filterables;

  @Action
  async getMany(data: { partnerId: string; data: MrfiktivMultipleIdsDtoGen }) {
    const response = await personService.getMany(data.partnerId, data.data);

    const companies = response.map(c => new Person(c));

    this.context.commit("addMany", companies);

    return companies;
  }

  @Mutation
  addMany(persons: IPerson[]) {
    persons.forEach(c => this._data.set(c));
  }
}

export const PersonModule = getModule(PersonPaginationStore);
